/* istanbul ignore next */
/* istanbul ignore next */
const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const camelCase = function(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};
export const getStyle =function(element, styleName) {
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
    }
  } catch (e) {
    return element.style[styleName];
  }
}

export function promiseAll(arr){
  return Promise.all(arr.map((promiseItem)=> {
    return promiseItem.catch((err)=>{
      return err;
    })
  }))
}
export const multipleHasEllipsis=(el)=>{
  const range = document.createRange();
  range.setStart(el, 0);
  range.setEnd(el, el.childNodes.length);
  const rangeHeight = range.getBoundingClientRect().height;
  const padding = (parseInt(getStyle(el, 'paddingTop'), 10) || 0) +
    (parseInt(getStyle(el, 'paddingBottom'), 10) || 0);

  return (rangeHeight + padding > el.offsetHeight || el.scrollHeight > el.offsetHeight)
}



// WEBPACK FOOTER //
// ./src/utils/index.js